const FLOAT_NOISE = 1e-9;

const wholePlantsUp = (eaches: number): number => Math.ceil(eaches - FLOAT_NOISE);

export default wholePlantsUp;
